import { Dropdown, Option } from "@fluentui/react-components";
import { OverflowTooltip } from "../OverflowTooltip/OverflowTooltip";
import { useStyles } from "./likertScalePicker.styles";
import { ILikertScalePickerProps } from "./likertScalePicker.types";

const NA_LABEL = "N/A";
const NA_VALUE = "0";
const SCALE_VALUES = ["1", "2", "3", "4", "5", NA_VALUE];

export const LikertScalePicker = ({
  accentPalette,
  labels,
  selectedValue,
  placeholder,
  disabled,
  onSelect,
}: ILikertScalePickerProps): JSX.Element => {
  const styles = useStyles();

  const getLabel = (value: string): string =>
    value === NA_VALUE ? NA_LABEL : (labels[value] ?? value);

  return (
    <div className={styles.wrapper}>
      <OverflowTooltip
        text={selectedValue ? getLabel(selectedValue) : ""}
        overflowSelector="button"
      >
      <Dropdown
        aria-label="Rate this statement"
        selectedOptions={selectedValue ? [selectedValue] : []}
        value={selectedValue ? getLabel(selectedValue) : ""}
        disabled={disabled}
        placeholder={placeholder}
        onOptionSelect={(_, data) => {
          if (data.optionValue) onSelect(data.optionValue);
        }}
        style={{
          width: "100%",
          ...(accentPalette
            ? {
                borderColor: accentPalette.accentOnWhite,
              }
            : {}),
        }}
      >
        {SCALE_VALUES.map((value) => {
          const selectedPalette =
            value === selectedValue ? accentPalette : undefined;

          return (
            <Option
              key={value}
              value={value}
              text={getLabel(value)}
              checkIcon={{
                style: {
                  color: selectedPalette?.accent,
                },
              }}
            >
              {getLabel(value)}
            </Option>
          );
        })}
      </Dropdown>
      </OverflowTooltip>
    </div>
  );
};
